import { useHistory, useParams } from "react-router";
import { ApiLoadingSpinner, ApiRequestError, BreadCrumb, Title } from "@funcional/react-ui";

import { useCreateRefundRules, useProducts, useStates, ICreateRefundRulesInputType, IRefundRules } from "../hooks";
import { FixedDiscountRuleForm } from "../components";
import { usePrograms } from "@refund/register-fixed-discount-rules/programs/hooks";

export default function CreateFixedDiscountRulePage() {
  let { programCode }: { programCode: string } = useParams();
  const filterProgram = {
    filter: {
      code: [programCode]
    }
  }
  const {
    status: fetchStatus,
    data: fetchData,
    error: fetchError,
  } = usePrograms(filterProgram);

  useProducts(programCode);
  useStates();
  const { isLoading, isSuccess, mutateAsync } = useCreateRefundRules();
  const history = useHistory();

  const getProductId = (productId) => parseInt(productId[0])
  const getStates = (statesId) => {
    /* a rule implemented in the backend considers that it is receiving all the states when we send an empty array */
    return (statesId.length === 26) ? [] : statesId.map(statesId => parseInt(statesId))
  }
  const getHeadquarters = (headquartersId) => headquartersId.map(headquartersId => parseInt(headquartersId))
  const ruleType = 'Rede'
  const getStartDate = (startDate) => new Date(startDate)
  const getEndDate = (endDate) => new Date(endDate)
  const getDiscountRanges = (ranges) => ranges.map(range => {
    return {
      discount: parseFloat(range.discount),
      discountRefund: parseFloat(range.discountRefund)
    }
  }
  )
  const getFormulaAttributes = (formulaAttributes) => {
    if (formulaAttributes === '["INDUSTRY_PRICE","MULTIPLICATION","DISCOUNT","MULTIPLICATION","SALE_QUANTITY"]' ||
      formulaAttributes === '["UNIT_PRICE","MULTIPLICATION","DISCOUNT","MULTIPLICATION","SALE_QUANTITY"]') {
      return JSON.parse(formulaAttributes);
    }

    throw new Error('Valor inválido para a fórmula a ser considerada no cálculo de ressarcimento, cheque os campos e tente novamente.')
  }

  const onSubmit = async (input: any) => {
    try {
      const inputFixedRule = {
        productId: getProductId(input.productId),
        states: getStates(input.statesId),
        headquarters: getHeadquarters(input.headquartersId),
        ruleType: ruleType,
        startDate: getStartDate(input.startDate),
        endDate: getEndDate(input.endDate),
        discountRanges: getDiscountRanges(input.ranges),
        formulaAttributes: getFormulaAttributes(input.formulaAttributes),
      } as ICreateRefundRulesInputType

      const record: IRefundRules = await mutateAsync(inputFixedRule);
      if (record?.rulesId) {
        window.alert(
          `Regra de desconto fixo salva com sucesso com o ID ${record.rulesId}!`
        );
        return history.push(
          `/refund/fixed-discount-rule/`
        );
      }
    } catch (error) {
      let message = ''

      if (error instanceof Error) {
        const startIndex = error.message.indexOf('### ERROR ###');
        const endIndex = error.message.indexOf(':', startIndex + '### ERROR ###'.length);
        const capitalizeFirstLetter = (string: string): string => string.charAt(0).toUpperCase() + string.slice(1);
        if (startIndex > -1 && endIndex > -1) {
          let serverMessage = `${error.message.substring(startIndex + '### ERROR ###'.length, endIndex).toLowerCase()}`
          message = `Retorno do servidor:${capitalizeFirstLetter(serverMessage)}`
        }
      }

      window.alert(
        `Não foi possível salvar o registro, tente novamente mais tarde. Caso o problema persista entre em contato com o administrador do sistema.\n\n${message}`
      );
    }
  };

  return (
    <>
      {fetchStatus === "loading" ? (
        <ApiLoadingSpinner />
      ) : fetchStatus === "error" ? (
        <ApiRequestError error={fetchError} />
      ) : fetchData && fetchData.edges?.length > 0 ? (
        <div>
          <Title>Nova Regra de Desconto Fixo</Title>

          <BreadCrumb
            items={[
              {
                path: "/refund/fixed-discount-rule",
                label: "Regras de Desconto Fixo"
              },
              {
                label: "Nova regra de desconto fixo"
              },
              {
                path: `/refund/fixed-discount-rule/new`,
                label: 'Programas',
              },
              {
                label: programCode,
              },
            ]}
          />
          <FixedDiscountRuleForm
            isLoading={isLoading || isSuccess}
            onSubmit={onSubmit}
            programCode={programCode}
          />
        </div>
      ) : (
        <div>Programa não encontrado.</div>
      )}
    </>
  );
}
